import script from "./LongRing.vue?vue&type=script&setup=true&lang=js"
export * from "./LongRing.vue?vue&type=script&setup=true&lang=js"

import "./LongRing.vue?vue&type=style&index=0&id=2bde4bb1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bde4bb1"]])

export default __exports__